module.exports = __webpack_public_path__ + "img/20200514_142218.afb032e1.jpg";